import React, { useEffect, useState, useRef, useCallback } from 'react';
import { Card } from 'react-bootstrap';
import '../StoneSearch/StoneSearch.css';
import '../../Pages/Mix/Transaction/MixMaster.css';
import diamondimage from '../../../src/Asset/Image/round_shape1.jpg';
import Loader from '../Utility/Loader';
import { FaHandHoldingMedical } from 'react-icons/fa6';

function PktSearchMobViewComp(props) {
    const [ShowMobView, setShowMobView] = useState();
    const [DataObj, setDataObj] = useState([]);
    

    const [selectionMode, setSelectionMode] = useState(false);
    const [selectedPktIds, setSelectedPktIds] = useState([]);
    const [selectedrow, setselectedrow] = useState([]);
    const longPressTimer = useRef(null);
    const [visibleCount, setVisibleCount] = useState(20);
    const observerTarget = useRef(null);

    useEffect(() => {
        setShowMobView(props.ShowMob);
    }, [props.ShowMob]);

    useEffect(() => {
        setDataObj(props.DataSrc);
        setVisibleCount(20);
        setSelectionMode(false);
        setselectedrow([]);
        setSelectedPktIds([]);
    }, [props.DataSrc]);

    const loadMore = useCallback(() => {
        setVisibleCount(prev => {
            const next = prev + 20;
            return next <= DataObj.length ? next : DataObj.length;
        });
    }, [DataObj.length]);

    useEffect(() => {
        props.onSelectedRowsChange && props.onSelectedRowsChange(selectedrow);
    }, [selectedrow]);

    useEffect(() => {
        const observer = new IntersectionObserver(
            entries => {
                if (entries[0].isIntersecting) {
                    loadMore();
                }
            },
            {
                root: null,
                rootMargin: '0px',
                threshold: 0.1,
            }
        );

        const currentObserverTarget = observerTarget.current;
        if (currentObserverTarget) {
            observer.observe(currentObserverTarget);
        }

        return () => {
            if (currentObserverTarget) {
                observer.unobserve(currentObserverTarget);
            }
        };
    }, [loadMore]);

    const handleLongPressStart = () => {
        longPressTimer.current = setTimeout(() => {
            setSelectionMode(true);
        }, 700);
    };

    const handleLongPressEnd = () => {
        clearTimeout(longPressTimer.current);
    };

    const handleCheckboxChange = (pktId) => {
        if (selectionMode) {
            setDataObj(prevData => {
                const updatedData = prevData.map(item => {
                    if (item.PKTID === pktId) {
                        return { ...item, SELECTED: !item.SELECTED };
                    }
                    return item;
                });

                const selectedIds = updatedData.filter(item => item.SELECTED).map(item => item.PKTID);
                const selectedData = updatedData.filter(item => item.SELECTED);

                setSelectedPktIds(selectedIds);
                setselectedrow(selectedData);
                return updatedData;
            });
        }

    };

    const visibleData = DataObj.slice(0, visibleCount);

    return (
        <>
            <Loader />
            {ShowMobView && (
                <div className='container-fluid d-flex justify-content-between align-items-center mb-2'>
                    <div className='row'>
                        {visibleData.map((x, index) => (
                            <div
                                className='col-12 col-lg-4 col-sm-12 col-md-6 pe-2'
                                key={index}
                                onMouseDown={handleLongPressStart}
                                onTouchStart={handleLongPressStart}
                                onMouseUp={handleLongPressEnd}
                                onMouseLeave={handleLongPressEnd}
                                onTouchEnd={handleLongPressEnd}
                            >
                                <Card striped bordered variant="dark" className='p-2 F13 mb-0 mt-2 mobile-card' onClick={() => handleCheckboxChange(x.PKTID)}>
                                    <div className="row d-flex justify-content-between">
                                        <div className={`col-1 d-flex align-items-start  transition-checkbox pt-2 px-2 ${selectionMode ? 'visible' : 'd-none'}`}
                                            style={{ transition: 'opacity 0.3s ease', opacity: selectionMode ? 1 : 0 }}
                                        >
                                            <input
                                                type="checkbox"
                                                checked={selectedPktIds.includes(x.PKTID)}
                                            />
                                        </div>
                                        <div className='col-3 text-center'>
                                            <div className='me-4'>
                                                <div className='pktid fw-bold '>{x.PKTID}</div>
                                                <img src={diamondimage} alt="" className='pt-2  img-fluid w-50 shape' />
                                                <div className='rap pt-2'>{x.S_NAME}</div>
                                                {
                                                    x.IsHold && <FaHandHoldingMedical size={15} color='#d90429'/>
                                                }
                                            </div>
                                        </div>

                                            <div className='col-3'>
                                                <div className='rap'>{x.I_CARAT} {x.C_NAME} {x.Q_NAME}</div>
                                                <div className='text-center d-flex pt-1'>FIN : {x.CT_NAME} {x.PO_NAME} {x.SY_NAME}</div>
                                                <div className='d-flex pt-1'>FLOU : {x.FL_NAME}</div> 
                                                <div className="pt-1">{x.LAB} :{x.CERTNO}</div>
                                            </div>

                                        <div className='col-3'>
                                            <div className=''>{x.LENGTH} - {x.WIDTH} * {x.HEIGHT}</div>
                                            <div className='d-flex pt-1'>T.: {x.TABLE_PER}</div>
                                            <div className="pt-1">D.: {x.TOTDEPTH_PER}</div>
                                            <div className="pt-1">RATIO : {x.RATIO}</div>
                                        </div>

                                        <div className='col-2 text-end pe-3'>
                                            <div className='rap'>RAP: {x.ORATE}</div>
                                            <div className='catat pt-1 fw-bold'> {x.DISC} % </div>
                                            <div className='pktid pt-1'>{x.RATE} $/CT</div>
                                            <div className="pt-1 rap">$ {x.AMT}</div>
                                        </div>
                                    </div>
                                </Card>
                            </div>
                        ))}
                        {visibleCount < DataObj.length && (
                            <div ref={observerTarget} className="mt-3 text-center">
                                <div>Loading more...</div>
                            </div>
                        )}
                    </div>
                </div>
            )}
        </>
    );
}

export default PktSearchMobViewComp;
